import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import SlideBox from '../SlideBox/SlideBox.jsx';
import {useLocation} from "react-router-dom";

import {StateType} from '../../types/StateType';

import moment from 'moment';

import BeschikbareVoertuigenChart from '../Chart/BeschikbareVoertuigenChart';

import {
  fetchPublicZones
} from '../Map/MapUtils/zones.js';

function HubStatsWidget({
  zone_id,
  ontwikkelingVan: controlledOntwikkelingVan,
  ontwikkelingTot: controlledOntwikkelingTot,
  onOntwikkelingChange,
}) {
  const [counter, setCounter] = useState(0)
  const [publicZones, setPublicZones] = useState(null)
  const [internalOntwikkelingVan, setInternalOntwikkelingVan] = useState(moment(moment().format('YYYY-MM-DD 00:00')))
  const [internalOntwikkelingTot, setInternalOntwikkelingTot] = useState(moment(moment().format('YYYY-MM-DD 00:00')))

  const isControlled = controlledOntwikkelingVan != null && controlledOntwikkelingTot != null
  const ontwikkelingVan = isControlled ? controlledOntwikkelingVan : internalOntwikkelingVan
  const ontwikkelingTot = isControlled ? controlledOntwikkelingTot : internalOntwikkelingTot

  const setDates = (van, tot) => {
    if (isControlled && onOntwikkelingChange) {
      onOntwikkelingChange(van, tot)
    } else {
      setInternalOntwikkelingVan(van)
      setInternalOntwikkelingTot(tot)
    }
  }

  const filterGebied = useSelector((state: StateType) => {
    return state.filter ? state.filter.gebied : 0;
  });

  const getPublicZones = async () => {
    const result = await fetchPublicZones(filterGebied);
    setPublicZones(result);
  }

  const filter = useSelector((state: StateType) => state.filter);

  useEffect(() => {
    getPublicZones();
  }, [filterGebied])

  const getZoneStats = (zone_id) => {
    const zoneIdAsNumber = parseInt(zone_id);
    if(! zoneIdAsNumber) return false;

    // Set some filter values
    const chartFilter = Object.assign({}, filter, {
      ontwikkelingvan: ontwikkelingVan.format(),
      ontwikkelingtot: ontwikkelingTot.format(),
      ontwikkelingaggregatie: 'hour',
      zones: ''+zoneIdAsNumber// Cast to string
    });

    return <div>
      <BeschikbareVoertuigenChart
        filter={chartFilter}
        config={{
          height: '200px',
          sumTotal: true,
        }}
        />
    </div>
  }

  const chartArrows = [
    {
      title: '<',
      link: () => {
        const newOntwikkelingVan = ontwikkelingVan.clone().subtract(1, 'day');
        const newOntwikkelingTot = ontwikkelingTot.clone().subtract(1, 'day');
        setDates(newOntwikkelingVan, newOntwikkelingTot);
        setCounter(counter+1);
      }
    },
    {
      title: '>',
      link: () => {
        const newOntwikkelingVan = ontwikkelingVan.clone().add(1, 'day');
        const newOntwikkelingTot = ontwikkelingTot.clone().add(1, 'day');
        setDates(newOntwikkelingVan, newOntwikkelingTot);
        setCounter(counter+1);
      }
    }
  ];

  const zoneStatsDiv = getZoneStats(zone_id);
  if(! zoneStatsDiv) return <div/>

  return (
    <div className="HubStatsWidget px-2 py-2">
      
      {zoneStatsDiv}

      <div className={"agg-button-container justify-center mt-4 mb-2"}>
        {chartArrows.map(x => {
          // Don't show '>' if it's in the future
          if(x.title === '>' && (ontwikkelingTot.unix()+86400) > moment().unix()) {
            return <div className="agg-button" style={{visibility: 'hidden'}} />;
          }
          return <div
            key={x.title}
            className="agg-button"
            onClick={x.link}
            >
            {x.title}
          </div>
        })}
      </div>

      <div className="mb-2 text-center">
        {moment(ontwikkelingVan).format('dddd')}
      </div>

    </div>
  )
}

export {
  HubStatsWidget
}
